module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    class: [_vm.styleType],
    style: ({
      cursor: _vm.cursorType
    }),
    on: {
      "click": function($event) {
        return _vm.clickItem(_vm.act.sounds[0])
      },
      "touchstart": function($event) {
        return _vm.onTouchStart()
      },
      "touchend": function($event) {
        return _vm.onTouchEnd()
      },
      "touchmove": function($event) {
        return _vm.onTouchEnd()
      }
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchInBtn),
      expression: "showPinchInBtn"
    }],
    staticClass: "icon-pinch-in",
    on: {
      "click": function($event) {
        return _vm.clickPinchInAct()
      }
    }
  }), _vm._v(" "), (_vm.isMobile()) ? [(_vm.sreUse === 'true') ? _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBasicText),
      expression: "showBasicText"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.basicText)
    }
  })]) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBasicText),
      expression: "showBasicText"
    }],
    staticClass: "select"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.isTileChallenge ? _vm.tileTextHtml : _vm.basicText)
    }
  })])] : [(_vm.sreUse === 'true') ? _c('div', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBasicText),
      expression: "showBasicText"
    }],
    class: _vm.getMilestoneTextFontClassAct(_vm.basicText, _vm.$parent.productLanguage)
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.basicText))
    }
  })])]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBasicText),
      expression: "showBasicText"
    }],
    staticClass: "select",
    class: _vm.getMilestoneTextFontClassAct(_vm.basicText, _vm.$parent.productLanguage)
  }, [(_vm.isTileChallenge) ? _c('div', [_c('div', {
    staticClass: "tile"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.tileTextHtml))
    }
  })])]) : _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.basicText))
    }
  })])])])], _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.sreUse !== 'true') ? _c('div', {
    class: {
      correct: _vm.isCorrect,
      incorrect: _vm.isIncorrect
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.act.image
    }
  })]), _vm._v(" "), (_vm.showVoiceIcon) ? _c('button', {
    staticClass: "icon-voice"
  }) : _vm._e()])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e83679a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-2e83679a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/MilestoneAct.vue
// module id = 860
// module chunks = 1